import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full px-[24px] mx-auto w-auto min-w-full" }
const _hoisted_2 = { class: "max-w-[1624px] h-full w-full mx-auto flex flex-col" }
const _hoisted_3 = { class: "relative flex-grow mt-[12px] mb-[16px]" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { Agent_WhereInput, useAgentsQuery } from '@/graphql/codegen/generated/graphql';
import { IKAgentsDrawerFilter, IKEventHub } from '@/types/injectionKeys';
import { computed, inject, onBeforeMount, onUnmounted, provide } from 'vue';
import { useStore } from 'vuex';
import coordinatorStatusBar from '@/components/common/coordinatorStatusBar/coordinatorStatusBar.vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useAgentsColumnsManagement, useAgentsColumnsManagementProvider, useAgentsPagePersistentDataProvider, useAgentsQueryFilterProvider } from '@/views/agents/agents.helpers';
import { useOsService } from '@/services/OsService/OsService';
import { useIncrediDialog } from 'incredi-ui';
import { NetworkStatus } from '@apollo/client/core';
import { useAgentsTableUtils } from '@/views/agents/components/agents-table/agent-table-list/OS/agents-table.utils';
import { useAgentsTableConstantsProvider } from '@/views/agents/components/agents-table/agents-table.const';
import { useAgentsSelectedProvider } from '@/views/agents/components/agents-table/agents-table.helpers';
import { useAgentTableFiltersProvider } from '@/components/agents-table/components/AgentTableFilters/AgentTableFilters.helpers';
import { IKAgentsSelected } from './components/agents-table/agents-table.InjectionKeys';
import AgentsNavBar from './components/agents-nav-bar.vue';
import AgentsTable from './components/agents-table/agents-table.vue';
import { IKAgents, IKAgentsQueryFilter } from './agents.injectionKeys';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents',
  setup(__props) {

useAgentsPagePersistentDataProvider();
useAgentsTableConstantsProvider();
useAgentsColumnsManagementProvider();
useAgentsQueryFilterProvider();
useAgentTableFiltersProvider();
useAgentsSelectedProvider();

const osService = useOsService();
const coordinatorsService = inject(IKCoordinatorsService);
const tableColumns = useAgentsColumnsManagement()?.tableColumns;
const agentsDrawerFilter = inject(IKAgentsDrawerFilter);
const agentsQueryFilter = inject(IKAgentsQueryFilter);
const selectedAgents = inject(IKAgentsSelected);
const pollIntervalAgentsQuery = 2000;
const store = useStore();
const eventHub = inject(IKEventHub);
const dialog = useIncrediDialog();
const agentsTableUtils = useAgentsTableUtils();

const filterPayload = computed(() => {
  const payload = {
    coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
    ...((agentsDrawerFilter?.GQL_AgentsFilter?.value as Agent_WhereInput) || {}),
    ...(agentsQueryFilter?.get.value || {}),
  };
  if (agentsDrawerFilter?.filter.value.quickFilter?.agentsIdFilter) payload.agentsIdFilter = selectedAgents?.selectedAgentIds.value.size ? Array.from(selectedAgents?.selectedAgentIds.value) : [''];
  return payload;
});
const agents = useAgentsQuery(
  () => ({
    filter: filterPayload.value,
  }),
  {
    fetchPolicy: 'no-cache',
    pollInterval: pollIntervalAgentsQuery,
  },
);

agents.onResult(result => {
  if (result.networkStatus === NetworkStatus.ready) {
    const currentSelected = new Set(selectedAgents?.selectedAgentIds.value);

    result.data?.agents?.agents?.forEach(agent => {
      if (agent?.id && agentsTableUtils.isCloudAgentInStatusStoppedOrUpdating(agent)) {
        currentSelected.delete(agent?.id);
      }
    });
    if (currentSelected.size !== selectedAgents?.selectedAgentIds.value?.size) {
      selectedAgents?.selectByIds(currentSelected);
    }
  }
});

onBeforeMount(() => {
  store.commit('main/SET_LD_COMPONENT', { component: 'AgentTableFilters', title: 'Filters' });
});

onUnmounted(() => {
  eventHub?.$emit('closeLeftDrawer');
  dialog?.close('manageBuildGroupsDialog');
  dialog?.close('manageBuildCacheClustersDialog');
});

provide(IKAgents, agents.result);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { style: {"margin":"0 auto","width":"100%","display":"inline-flex","flex-direction":"column"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(AgentsNavBar),
          _createElementVNode("div", _hoisted_3, [
            (_unref(tableColumns) && _unref(tableColumns)[_unref(osService).osType.value] && _unref(agentsDrawerFilter)?.GQL_AgentsFilter && _unref(agents).networkStatus.value === _unref(NetworkStatus).ready)
              ? (_openBlock(), _createBlock(AgentsTable, {
                  key: 0,
                  class: "w-full h-full absolute",
                  columns: _unref(tableColumns)[_unref(osService).osType.value].value as any,
                  "agents-query-result": _unref(agents).result.value?.agents,
                  onOnScroll: _cache[0] || (_cache[0] = ({ isScrolling }) => (isScrolling ? _unref(agents).stop() : _unref(agents).start()))
                }, null, 8, ["columns", "agents-query-result"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(coordinatorStatusBar)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})